import { populateMenu } from './menu';

/**
 * Toggles the visibility of the mobile menu.
 *
 * @param {HTMLElement} menu - The mobile menu element.
 */
export function toggleMobile(menu: HTMLElement) {
	const className = 'mobile-open';
	if (menu.classList.contains(className)) {
		menu.classList.remove(className);
	} else {
		showMobile(menu.dataset.current || '');
		menu.classList.add(className);
	}
}

/**
 * Shows the mobile menu and populates it with the specified menu level.
 *
 * @param {string} id - The ID of the menu to show.
 */
export function showMobile(id: string) {
	const mobileMenu = document.getElementById('mobile-menu');
	const mobileMain = document.getElementById('mobile-main');
	if (!mobileMenu || !mobileMain) return;

	const targetId = id || 'root';
	mobileMenu.dataset.current = targetId;

	const parentId = populateMenu(mobileMain, targetId);
	updateBackButton(parentId);
}

/**
 * Updates the "back" button in the mobile menu.
 *
 * @param {string} parentId - The ID of the parent menu level.
 */
function updateBackButton(parentId: string) {
	const mobileTop = document.getElementById('mobile-top');
	if (!mobileTop) return;

	mobileTop.innerHTML = '';

	if (parentId) {
		const button = document.createElement('button');
		button.className = 'back';
		button.textContent = 'Takaisin';
		button.dataset.goto = parentId;
		mobileTop.appendChild(button);
	}
}

/**
 * Event delegation for mobile menu internal navigation.
 * This ensures sub-menu navigation and back buttons work even when content is swapped.
 */
document.addEventListener('click', (event) => {
	const target = event.target as HTMLElement;

	// 1. Mobile Sub-menu Navigation
	const subLink = target.closest('#mobile-menu [data-menu-open]');
	if (subLink instanceof HTMLElement) {
		const id = subLink.dataset.menuOpen;
		if (id) {
			showMobile(id);
		}
		return;
	}

	// 2. Mobile Back Button
	const backButton = target.closest('#mobile-menu .back');
	if (backButton instanceof HTMLElement) {
		const id = backButton.dataset.goto;
		if (id) {
			showMobile(id);
		}
		return;
	}
});
